// extracted by mini-css-extract-plugin
export default {"c-icon":"new-impact-action_component_c-icon__R3yXL"};